package es.subastia.utils

fun Double.formatMoney(): String {
    val intPart = this.toLong()
    val decimalPart = ((this - intPart) * 100).toInt()
    // Ensure 2 decimal places
    val decimalStr = if (decimalPart < 10) "0$decimalPart" else "$decimalPart"
    
    return "${addThousandSeparators(intPart)},$decimalStr"
}

private fun addThousandSeparators(number: Long): String {
    return number.toString().reversed().chunked(3).joinToString(".").reversed()
}
